<template>
    <Modal v-model="departmentFormShow" title="部门信息">
        <Form label-position="top">
            <Row :gutter="16">
                <Col span="12">
                    <FormItem label="部门名称">
                        <Input v-model="departmentForm.departmentName"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="联系人">
                        <Input
                            v-model="departmentForm.departmentContact"
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="手机">
                        <Input v-model="departmentForm.departmentPhone"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="类型">
                        <Select v-model="departmentForm.departmentType">
                            <Option :value="DEPARTMENT_TYPE_BINFEN">{{
                                DEPARTMENT_TYPE_BINFEN
                            }}</Option>
                            <Option :value="DEPARTMENT_TYPE_EXTERNAL">{{
                                DEPARTMENT_TYPE_EXTERNAL
                            }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="状态">
                        <RadioGroup
                            v-model="departmentForm.departmentStatus"
                            type="button"
                        >
                            <Radio
                                v-for="item in statusOptions"
                                :key="item.val"
                                :label="item.val"
                                >{{ item.label }}
                            </Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="公司">
                        <Select
                            v-model="departmentForm.companyUuid"
                            clearable
                            filterable
                        >
                            <Option
                                v-for="item in companyList"
                                :key="item.id"
                                :value="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="success" class="form-button" @click="onSave"
                >保存</Button
            >
            <Button type="text" class="form-button" @click="onCancel"
                >取消</Button
            >
        </div>
    </Modal>
</template>
<script>
import search from "@/libs/search";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
import {
    DEPARTMENT_TYPE_BINFEN,
    DEPARTMENT_TYPE_EXTERNAL
} from "@/view/system-management/department-management/DepartmentTypeDefine";
import {
    STATUS_ACTIVE,
    STATUS_INACTIVE,
    statusFormat
} from "@/libs/baseModelFormat";
import {
    saveDepartment
} from "@/api/modules/system-management/department-management";
import { getCompanyList } from '@/api/modules/system-management/company-management';

export default {
    data() {
        return {
            DEPARTMENT_TYPE_BINFEN,
            DEPARTMENT_TYPE_EXTERNAL,
            departmentForm: {
                formEditMode: "",
                departmentUuid: "",
                departmentName: "",
                departmentContact: "",
                departmentPhone: "",
                departmentType: DEPARTMENT_TYPE_BINFEN,
                departmentStatus: STATUS_ACTIVE,
                companyUuid: ""
            },
            departmentFormShow: false,
            companyList: []
        };
    },
    computed: {
        statusOptions() {
            return [
                { val: STATUS_ACTIVE, label: statusFormat(STATUS_ACTIVE) },
                { val: STATUS_INACTIVE, label: statusFormat(STATUS_INACTIVE) }
            ];
        }
    },
    methods: {
        showModal(
            mode = FORM_EDIT_MODE_CREATE,
            departmentUuid = "",
            departmentName = "",
            departmentContact = "",
            departmentPhone = "",
            departmentType = DEPARTMENT_TYPE_BINFEN,
            departmentStatus = STATUS_ACTIVE,
            companyUuid = ""
        ) {
            this.departmentForm.formEditMode = mode;
            if (mode == FORM_EDIT_MODE_MODIFY) {
                this.departmentForm.departmentUuid = departmentUuid;
                this.departmentForm.departmentName = departmentName;
                this.departmentForm.departmentContact = departmentContact;
                this.departmentForm.departmentPhone = departmentPhone;
                this.departmentForm.departmentStatus = departmentStatus;
                this.departmentForm.departmentType = departmentType;
                this.departmentForm.companyUuid = companyUuid;
            }
            else {
                this.Init();
            }
            this.departmentFormShow = true;
            
            this.getCompanyList();
        },
        Init() {
            this.departmentForm.departmentUuid = "";
            this.departmentForm.departmentName = "";
            this.departmentForm.departmentContact = "";
            this.departmentForm.departmentPhone = "";
            this.departmentForm.departmentStatus = STATUS_ACTIVE;
            this.departmentForm.departmentType = DEPARTMENT_TYPE_BINFEN;
            this.departmentForm.companyUuid = "";
        },
        onSave() {
            if (!this.departmentForm.departmentName.trim()) {
                this.$Message.error('部门名称不能为空');
                return;
            }
            
            const data = Object.assign({}, this.departmentForm);
            saveDepartment(data)
                .then((res) => {
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.departmentFormShow = false;
                                this.getDepartmentTableRecords();
                                this.$emit('refresh');
                            }
                        });
                    }
                    else {
                        this.$Message.error(res.message || '保存失败');
                    }
                })
                .catch((error) => {
                    console.error('保存部门失败:', error);
                    this.$Message.error('保存失败');
                });
        },
        onCancel() {
            this.departmentFormShow = false;
        },
        async getCompanyList() {
            try {
                const tableSearch = search.getSearchParams();
                search.closeAllConditions(tableSearch);
                const res = await getCompanyList(tableSearch);
                if (res.code === 0) {
                    this.companyList = res.data.records || [];
                }
                else {
                    this.$Message.error(res.message || '公司列表查询失败');
                }
            }
            catch (error) {
                console.error('获取公司列表失败:', error);
                this.$Message.error('公司列表查询失败');
            }
        }
    }
};
</script>

<style scoped></style>
